import { httpClient, type ID } from '#shared'
import type { SendMessagePayload } from '../model/send-message-payload'
import type { SendMessageResponse } from '../model/send-message-response'

export async function sendMessage(chatId: ID, payload: SendMessagePayload) {
  if (payload.respondFor) {
    payload.respondFor = {
      id: payload.respondFor.id,
    }
  }

  const response = await httpClient.post<SendMessageResponse>(`chats/${chatId}/messages`, {
    json: payload,
    requireAuth: true,
  })

  const responseBody = await response.json()

  return responseBody
}
